import { createContext, Dispatch, useContext } from "react";

import {
  endEqSession,
  EqSessionAction,
  startEqSession
} from "./useEqSessionReducer";

export const EqSessionDispatchContext = createContext<
  Dispatch<EqSessionAction>
>(() => {});

export function useEqSessionDispatchContext() {
  const dispatch = useContext(EqSessionDispatchContext);

  const endSession = () => dispatch(endEqSession());

  const startSession = ({
    newSessionId,
    questionIds,
    mockId
  }: {
    questionIds: string[];
    newSessionId: string;
    mockId?: string;
  }) => {
    dispatch(
      startEqSession({
        sessionId: newSessionId,
        questionIds,
        mockId
      })
    );
  };

  return {
    startEqSession: startSession,
    endEqSession: endSession
  };
}
